// extracted by mini-css-extract-plugin
module.exports = {"purchaseComplete":"PurchaseCompleteDialog_purchaseComplete__3a2ZI","stars":"PurchaseCompleteDialog_stars__1sy35","returnToVideo":"PurchaseCompleteDialog_returnToVideo__whh_K"};